import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROUTE_PATH } from '../../../../constants';
import ConnectedAccountForm from './ConnectedAccountForm';
import { CredentialRequest, CredentialSecret } from '../../../../types';
import { apiRawFetch } from '../../../../APIClient';
import { useRedirectCallback, useTrashablePromise } from '../../../../hooks';
import { APIError } from '../../../../APIError';
import { memoizedCredentialSchemaSelector } from '../../../../selectors/credentialSchemaSelectors';

type Props = {
  onSuccess: (newCredential: CredentialSecret) => void;
};

export const AddNewAccount: React.FunctionComponent<Props> = ({
  onSuccess,
}) => {
  const { type } = useParams<{ type: string }>();
  const schemaSelector = React.useMemo(
    () => memoizedCredentialSchemaSelector.getSchemaByType(type),
    [type],
  );
  const schema = useSelector(schemaSelector)!;

  const onGoBack = useRedirectCallback(
    ROUTE_PATH.SELF_SERVICE.CONNECTED_ACCOUNTS.NEW,
  );

  const { registerPromise } = useTrashablePromise();

  const onSubmit = React.useCallback(
    async (payload: CredentialRequest, setError: (error: APIError) => void) => {
      try {
        const { credential } = await registerPromise(
          apiRawFetch.createCredential(payload),
        );
        onSuccess(credential);
      } catch (err) {
        setError(err);
      }
    },
    [onSuccess, registerPromise],
  );

  return (
    <ConnectedAccountForm
      onCancel={onGoBack}
      onSubmit={onSubmit}
      schema={schema}
      credential={null}
    />
  );
};
